import React, { useEffect, useState } from "react";
import Style from "../Style/Footer.module.scss";
import logo from "../Img/logo9.png";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
const baseURL = process.env.REACT_APP_BASE_URL;

const Footer = ({ darkMode }) => {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseURL}/api/get/skills`)
      .then((res) => {
        setSkills(res.data);
      })
      .catch((err) => {
        console.error("Error fetching skills:", err);
      });
  }, []);

  return (
    <footer className={`${Style.Footer} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.wrapper}>
        <div className={Style.FooterFlex}>
          <div className={Style.footerCol}>
            <img src={logo} alt="Optimyz" className={Style.logo} />
            <p>Optimyz Learning of skills training</p>
            <p>
              To become a trusted catalyst in personal and professional
              transformation by nurturing confident, conscious, and future-ready
              individuals
            </p>
            <div className={Style.socialIcons}>
              <FaLinkedin />
              <FaInstagram />
            </div>
          </div>
          <div className={Style.footerCourcesDisk}>
            <h4>Courses</h4>
            <ul>
              {skills.map((skill) => (
                <li key={skill.id}>
                  <Link
                    to={`/${skill.title.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {skill.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={Style.footerNavigation}>
            <h4>Navigation</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <Link to="/courses">Courses</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className={Style.footerContact}>
            <h4>Contact</h4>
            <p>D2-207, Nirala Aspire, GH-03, </p>
            <p>Sector -16B, Greater Noida West-201308</p>
            <p>
              <FaPhoneAlt /> 7506050108, 9051193920
            </p>
            <p>
              <FaEnvelope /> sinhalearningsolutions@gmail.com
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
